<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12>
        <v-stepper v-model="e1" vertical class="white elevation-8 stepper-customized pb-0">

          <v-stepper-step step="1" class="w-100" :editable="e1 > 1">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 1, 'md7':e1 > 1}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '1'}">
                    Seleccionar variables
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '1' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 1">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card class="transparent">
              <vue-perfect-scrollbar class="confirm-campaign--scrollbar">
                <v-card-text class="white pt-3 pr-3 pb-0 pl-5">
                  <v-list class="pl-5" two-line>
                    <template v-for="(column, i) in fillable_columns">
                      <v-list-tile :key="i" class="mr-5">
                        <v-layout justify-center align-center>
                          <v-flex xs1>
                            <v-checkbox class="mt-4 k-orange-linear-text" v-model="column.filtered" @change="fillVar($event, column)"></v-checkbox>
                          </v-flex>
                          <v-flex xs5 :class="{'f1-2em': true, 'grey--text': !column.filtered}">
                            <strong>{{column.text}}</strong>
                          </v-flex>
                          <v-flex xs6 class="pr-5">
                            <v-select
                              :items.sync="column.value === 'var_2' ? amount_columns : variable_columns"
                              v-model="structure[column.value]"
                              solo
                              color="black"
                              class="grey"
                              :disabled="!column.filtered"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-list>
                  <!-- <template v-else>
                    <v-layout justify-center align-center fill-height>
                      <v-flex md12 class="headline k-grey-light-text text-xs-center">
                        <img src="../../assets/img/loader.gif" width="100px"/>
                      </v-flex>
                    </v-layout>
                  </template> -->
                </v-card-text>
              </vue-perfect-scrollbar>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="getFilters">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="2" class="w-100" :editable="e1 > 2">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md9':e1 == 2, 'md7':e1 > 2}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '2'}">
                    Filtros
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '2' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md3 v-if="e1 == 2">
                <v-btn class="k-orange-linear-underline k-orange-linear-text" large block flat @click="cleanFilters">
                  LIMPIAR FILTROS
                </v-btn>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 2">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card class="transparent">
              <vue-perfect-scrollbar class="confirm-campaign--scrollbar">
                <v-card-text class="white pt-3 pr-3 pb-0 pl-5">
                  <v-list class="pl-5" two-line>
                    <template v-for="(column, i) in filters_columns">
                      <v-list-tile :key="i" class="mr-5">
                        <v-layout justify-center align-center>
                          <v-flex xs1>
                            <v-checkbox class="mt-4 k-orange-linear-text" v-model="column.filtered" @change="fillFilter($event, column)" :disabled="!column.enabled"></v-checkbox>
                          </v-flex>
                          <v-flex xs5 :class="{'f1-2em': true, 'grey--text': !column.filtered}">
                            <strong>{{column.text}}</strong>
                          </v-flex>
                          <v-flex xs6 class="pr-5">
                            <v-select
                              @focus="column.filtering = !column.filtering"
                              :items.sync="lists[column.list]"
                              item-text="text"
                              :item-value="column.id"
                              :key="column.key"
                              :id="column.key"
                              v-model="filters[column.value]"
                              solo
                              color="black"
                              class="grey"
                              :disabled="!column.filtered"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-list>
                  <!-- <template v-else>
                    <v-layout justify-center align-center fill-height>
                      <v-flex md12 class="headline k-grey-light-text text-xs-center">
                        <img src="../../assets/img/loader.gif" width="100px"/>
                      </v-flex>
                    </v-layout>
                  </template> -->
                </v-card-text>
              </vue-perfect-scrollbar>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear-underline k-orange-linear-text white-no-border" flat large @click="e1 -= 1">ANTERIOR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="getCustomersStatus">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="3" class="w-100" :editable="e1 > 3">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 3, 'md7':e1 > 3}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '3'}">
                    Clientes a enviar
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '3' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 3">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card class="transparent">
              <vue-perfect-scrollbar class="confirm-campaign--scrollbar">
                <v-card-text class="white pt-3 pr-3 pb-0 pl-5">
                  <v-list class="pl-5" v-if="statusOfCustomers.length > 0">
                    <v-list-tile v-for="(status, i) in statusOfCustomers" :key="i">
                      <v-layout align-center justify-center>
                        <v-flex md2 text-xs-right mr-3>
                          <v-icon small class="k-orange-linear-text">fa-{{icons[status.status ? status.status : 'Nulo']}}</v-icon>
                        </v-flex>
                        <v-flex md6 class="f1-1em">
                          {{status.status ? status.status : 'Nulo'}}: <span class="k-grey-text f0-8em">{{status.total}}</span>
                        </v-flex>
                        <v-flex md4 text-xs-center>
                          <v-checkbox v-model="selectedStatusOfCustomers" class="k-orange-linear-text mt-4 pa-0 ml-4 pl-3" :value="status.value ? status.value : 'Nulo'"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                  <v-list class="pl-5" v-else>
                    <v-list-tile>
                      <v-layout row wrap>
                        <v-flex md12 text-xs-center>
                          <p class="f1-5em">
                            No se encontraron clientes con los filtros indicados
                          </p>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                  <!-- <template v-else>
                    <v-layout justify-center align-center fill-height>
                      <v-flex md12 class="headline k-grey-light-text text-xs-center">
                        <img src="../../assets/img/loader.gif" width="100px"/>
                      </v-flex>
                    </v-layout>
                  </template> -->
                </v-card-text>
              </vue-perfect-scrollbar>
              <v-card-actions class="white px-0 mr-2">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear-underline k-orange-linear-text white-no-border" flat large @click="e1 -= 1">ANTERIOR</v-btn>
                    <v-btn class="k-orange-linear white--text elevation-1" large @click="searchTemplates" :disabled="selectedStatusOfCustomers.length === 0">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-step step="4" class="w-100" :editable="e1 > 4">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 4, 'md7':e1 > 4}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '4'}">
                    {{ campaign.channel === 'human' ? 'Plantilla de reenvio SMS al final del dia' : 'Plantilla' }}
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{e1 == '4' ? campaign.name : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 4">
                Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
              </v-flex>
              <v-flex md5 pl-2 v-if="e1 == '4'">
                <v-select
                v-model="template"
                :items="templates"
                item-text="name"
                return-object
                v-validate="'required'"
                data-vv-name="template_id"
                data-vv-as="plantilla"
                :error-messages="errors.collect('template_id')"
                label="Plantilla de campaña"
                class="a-borders elevation-0"
                color="grey"
                solo>
                </v-select>
              </v-flex>
            </v-layout>
          </v-stepper-step>
          <v-stepper-content step="4">
            <template v-if="templates.length > 0">
              <v-card class="transparent" v-if="(campaign.channel === 'email' || campaign.channel === 'bot') && (template.status === 'activo' || template.status === 'Activo')">
                <v-card-text class="white">
                  <vue-editor v-model="text" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="editorToolbar" v-if="campaign.channel === 'email'"></vue-editor>
                  <template v-else>
                    <div class="f1-5em text-xs-center my-3"> 
                      {{`De click a siguiente si el flujo de bot ${template.name} es el que desea enviar`}} 
                    </div>
                  </template>
                </v-card-text>
                <v-card-actions class="white px-0 mr-2">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear-underline k-orange-linear-text white-no-border" flat large @click="e1 -= 1">ANTERIOR</v-btn>
                      <v-btn class="k-orange-linear white--text" large @click="campaign.channel === 'bot' ? e1 = e1 += 1 : updateTemplate(campaign.channel, template)">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
              <v-card :height="'300px'" v-if="(campaign.channel === 'sms' || campaign.channel === 'ivr' || campaign.channel === 'human') && template.status === 'activo'">
                <v-card-text class="white">
                  <textarea
                    v-model="text"
                    v-validate="`required|max:${campaign.channel === 'sms' || campaign.channel === 'human' ? '160' : '10000'}`"
                    data-vv-name="text"
                    data-vv-as="texto"
                    placeholder="Texto"
                    :class="{awesomplete: true, 'has-error': errors.has('text') || (textLength > 160 && campaign.channel === 'sms'), 'campaign': true}"
                    data-multiple
                    spellcheck="false">
                  </textarea>
                  <small class="custom-error" id="text-error" v-if="errors.has('text')">
                    {{ errors.first('text') }}
                  </small>
                  <small class="custom-error" v-if="campaign.channel === 'sms' && !errors.has('text') && textLength < 160">
                    160 / {{ textLength }}
                  </small>
                  <small class="custom-error" :id="textLength > 160 ? 'text-error' : ''" v-if="campaign.channel === 'sms' && !errors.has('text') && textLength > 160">
                    El texto no debe ser mayor a 160 caracteres, cada variable suma 10 caracteres al texto
                  </small>
                </v-card-text>
                <v-card-actions class="white px-0 mr-2 custom-actions">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear white--text" large @click="updateTemplate(campaign.channel, template)">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </template>
            <template v-else>
              <v-card class="transparent" height="200px">
                <v-card-text fill-height>
                  <v-layout justify-center align-center fill-height>
                    <v-flex md11 class="f1-4em text-xs-center">
                      <v-icon>fas fa-info-circle</v-icon>
                      No hay plantillas activas o no existen plantillas para este canal
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="white px-0 mr-2 mt-4">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear white--text" large :disabled="true">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>
          <template v-if="campaign.channel !== 'bot'">
            <v-stepper-step step="5" class="w-100" :editable="e1 > 5">
              <v-layout justify-center align-center class="w-100">
                <v-flex :class="{'f1-2em text-light':true, 'md7':e1 == 5, 'md7':e1 > 5}">
                  <v-layout row wrap>
                    <v-flex md12 class="f1-5em" :class="{'black--text':e1 == '5'}">
                      Ejemplo de plantilla
                    </v-flex>
                    <v-flex md12 class="f0-8em grey--text">
                      {{e1 == '5' ? campaign.name : ''}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md5 class="k-orange-linear-text f1-5em text-light text-xs-right pr-3" v-if="e1 > 5">
                  Completado <v-icon class="k-orange-linear-text pl-2">fas fa-check</v-icon>
                </v-flex>
              </v-layout>
            </v-stepper-step>
            <v-stepper-content step="5">
              <v-card class="transparent" v-if="template.status === 'activo'">
                <v-card-text class="white">
                  <div class="ml-3 pt-3 custom-text h-2" v-html="formatedText(template.text ? template.text : '')" v-if="template.text && campaign.channel == 'email'" />
                  <div class="ml-3 pt-3 f1-2em italic" v-if="campaign.channel != 'email'" v-html="formatedText(template[campaign.channel == 'human' ? 'sms' : campaign.channel] ? template[campaign.channel == 'human' ? 'sms' : campaign.channel] : '')" />
                </v-card-text>
                <v-card-actions class="white px-0 mr-2">
                  <v-layout row wrap class="px-0">
                    <v-flex md12 text-xs-right>
                      <v-btn flat large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                      <v-btn class="k-orange-linear-underline k-orange-linear-text white-no-border" flat large @click="e1 -= 1">ANTERIOR</v-btn>
                      <v-btn class="k-orange-linear white--text" large @click="e1 += 1">SIGUIENTE</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </template>
          <v-stepper-step :step="campaign.channel === 'bot' ? '5' : '6'" class="w-100">
            <v-layout justify-center align-center class="w-100">
              <v-flex :class="{'f1-2em text-light md12':true}">
                <v-layout row wrap>
                  <v-flex md12 class="f1-5em" :class="{'black--text':campaign.channel === 'bot' ? e1 == '6' : e1 == '7'}">
                    Información de campaña
                  </v-flex>
                  <v-flex md12 class="f0-8em grey--text">
                    {{campaign.channel === 'bot' ? e1 == '6' || e1 == '7' ? campaign.name : '' : ''}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-flex md4 v-if="e1 == '3'">
                <v-select
                  :items="deliveryOptions"
                  v-model="form.delivery_option"
                  color="grey"
                  item-text="name"
                  item-value="value"
                  class="a-borders elevation-0"
                  label=""
                  solo
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-stepper-step>
          <v-stepper-content :step="campaign.channel === 'bot' ? '5' : '6'">
            <v-card class="transparent">
              <v-card-text class="white pt-3 pr-3 pb-3 pl-0 elevation-0">
                <v-layout row wrap>
                  <v-flex md6 px-4>
                    <v-layout row wrap>
                      <v-flex md12 px-1 v-for="option in deliveryOptions" :key="`${option.value}_option`">
                        <v-btn block round large :disabled="option.disabled" :outline="option.value !== form.delivery_option" :class="{'k-orange-linear white--text':option.value === form.delivery_option, 'k-orange-linear-underline k-orange-linear-text elevation-0':option.value !== form.delivery_option}" @click="form.delivery_option = option.value">
                          <v-icon small class="pr-2">{{option.icon}}</v-icon> {{option.name}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <div class="accordion-content">
                          <v-divider v-if="form.delivery_option === 'Agendada'" class="white"></v-divider>
                          <v-layout row wrap :class="{'content':true, 'open':form.delivery_option === 'Agendada', 'close':form.delivery_option !== 'Agendada'}">
                            <v-flex md6 pr-2>
                              <v-menu
                                ref="date"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_date"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartDate"
                                  color="grey"
                                  append-icon="event"
                                  label="Inicio de campaña"
                                  readonly>
                                </v-text-field>
                                <v-date-picker
                                  v-model="form.start_date"
                                  @input="$refs.date.save(form.start_date)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex md6 pl-2>
                              <v-menu
                                ref="time"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.start_hour"
                                transition="scale-transition"
                                min-width="290px"
                                lazy
                                offset-y
                                full-width>
                                <v-text-field
                                  slot="activator"
                                  v-model="formatedStartHour"
                                  color="grey"
                                  append-icon="fas fa-clock"
                                  label="Horario de inicio"
                                  readonly>
                                </v-text-field>
                                <v-time-picker
                                  v-model="form.start_hour"
                                  @input="$refs.time.save(form.start_hour)"
                                  locale="es"
                                  color="k-orange-linear">
                                </v-time-picker>
                              </v-menu>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md6>
                    <div class="a-borders">
                      <v-layout justify-center align-center pl-4>
                        <v-flex md3 class="top-4 k-orange-linear text-xs-center pb-5 pt-5">
                          <v-icon class="white--text" large>fas fa-flag</v-icon>
                        </v-flex>
                        <v-flex md9>
                          <v-layout justify-start align-center px-3 pt-2>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-2em">
                                  {{campaign ? campaign.name : ''}}
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{template.status === 'activo' ? template.name : ''}}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center pb-2 pt-2 pl-3>
                            <v-flex md12>
                              <v-layout row wrap>
                                <v-flex md12 class="f1-1em">
                                  Fecha de incio
                                </v-flex>
                                <v-flex md12 class="f0-9em k-grey-text">
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(form.start_date ? form.start_date : new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') : formatDate(new Date(), 'YYYY-MM-DD', 'DD/MM/YYYY') }}
                                  {{campaign.delivery_option ? campaign.delivery_option === 'Inmediata' ? formatDate(new Date(), 'H:mm', 'h:mm A') : formatDate(form.start_hour ? form.start_hour : new Date(), 'H:mm a', 'h:mm A') : formatDate(new Date(), 'H:mm', 'h:mm A') }}
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="white px-0 pb-4 mr-5">
                <v-layout row wrap class="px-0">
                  <v-flex md12 text-xs-right>
                    <v-btn flat color="black" large @click="$router.push('/campaigns')">CANCELAR</v-btn>
                    <v-btn class="k-orange-linear-underline k-orange-linear-text white-no-border" flat large @click="e1 -= 1">ANTERIOR</v-btn>
                    <v-btn class="k-orange-linear white--text" large @click="confirmDeliveryOption" :disabled="errors.any()">SIGUIENTE</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import moment from 'moment';
import DataTable from '@/components/global/DataTable';
import campaignVarLists from '@/components/campaign_var/CampaignVarList';
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';

const qs = require('qs');

Vue.component('campaignVarLists', campaignVarLists);

export default {
  inject: ['$validator'],
  mixins: [
    emailEditorToolbarMixin,
  ],
  components: {
    DataTable,
    VuePerfectScrollbar,
    VueEditor,
  },
  created() {
    this.getCampaign();
  },
  data() {
    return {
      e1: 1,
      text: '',
      status: {},
      campaign: {},
      template: {},
      templates: [],
      customer: {},
      dialogTest: false,
      alertDialog: false,
      dialogOption: false,
      statusOfCustomers: [],
      selectedStatusOfCustomers: [],
      customerColumns: [],
      selectedColumns: [],
      renderList: null,
      list_order: {
        tranche_id: 0,
        agency_id: 1,
        delinquency: 2,
        due_day_id: 3,
        portfolio_type_id: 4,
      },
      form: {
        to: '',
        name: '',
        delivery_option: 'Inmediata',
      },
      deliveryOptions: [
        {
          value: 'Inmediata',
          disabled: false,
          name: 'Inmediata',
          icon: 'fas fa-calendar-alt',
        },
      ],
      mask_columns: {
        first_name: 'Nombre',
        last_name: 'Apellido',
        agency_id: 'Agencia',
        account: 'Cuenta',
        type_id: 'Tipo',
        fiscal_id: 'RUT/DNI/CI',
        birthday: 'Fecha de cumpleaños',
        age: 'Edad',
        gender: 'Genero',
        marital_status: 'Estado civil',
        seniority: 'Antiguedad',
        due_date: 'Fecha de vencimiento',
        due_day_id: 'Dia de vencimiento',
        invoiced_balance: 'Monto de deuda',
        status_id: 'Estado',
        portfolio_type_id: 'Cartera',
        account_type_id: 'Tipo de cuenta',
        delinquency: 'Mora',
        tranche_id: 'Tramo de mora',
      },
      variable_columns: [
        {
          text: 'Fecha vencimiento',
          value: 'due_date',
        },
        {
          text: 'RUT/DNI/CI',
          value: 'fiscal_id',
        },
        {
          text: 'Mora',
          value: 'delinquency',
        },
      ],
      amount_columns: [
        {
          text: 'Balance de deuda',
          value: 'due_balance',
        },
        {
          text: 'Balance facturado',
          value: 'invoiced_balance',
        },
        {
          text: 'Balance total',
          value: 'total_balance',
        },
      ],
      fillable_columns: [
        {
          text: '@var_1',
          value: 'var_1',
          select: true,
          filtered: false,
        },
        {
          text: '@monto',
          value: 'var_2',
          select: true,
          filtered: false,
        },
        {
          text: '@var_3',
          value: 'var_3',
          select: true,
          filtered: false,
        },
        {
          text: '@var_4',
          value: 'var_4',
          select: true,
          filtered: false,
        },
        {
          text: '@var_5',
          value: 'var_5',
          select: true,
          filtered: false,
        },
        {
          text: '@var_6',
          value: 'var_6',
          select: true,
          filtered: false,
        },
        {
          text: '@var_7',
          value: 'var_7',
          select: true,
          filtered: false,
        },
        {
          text: '@var_8',
          value: 'var_8',
          select: true,
          filtered: false,
        },
        {
          text: '@var_9',
          value: 'var_9',
          select: true,
          filtered: false,
        },
        {
          text: '@var_10',
          value: 'var_10',
          select: true,
          filtered: false,
        },
        {
          text: '@var_11',
          value: 'var_11',
          select: true,
          filtered: false,
        },
        {
          text: '@var_12',
          value: 'var_12',
          select: true,
          filtered: false,
        },
        {
          text: '@var_13',
          value: 'var_13',
          select: true,
          filtered: false,
        },
        {
          text: '@var_14',
          value: 'var_14',
          select: true,
          filtered: false,
        },
        {
          text: '@var_15',
          value: 'var_15',
          select: true,
          filtered: false,
        },
      ],
      filters_columns: [
        {
          text: 'Agencia',
          value: 'agency_id',
          id: 'id',
          select: true,
          filtered: false,
          filtering: false,
          enabled: true,
          key: '0316',
          list: 1,
        },
        {
          text: 'Dia de vencimiento',
          value: 'due_day_id',
          id: 'id',
          select: true,
          filtered: false,
          filtering: false,
          enabled: true,
          key: '0318',
          list: 3,
        },
        {
          text: 'Tramo de mora',
          value: 'tranche_id',
          id: 'id',
          select: true,
          filtered: false,
          filtering: false,
          enabled: true,
          key: '0315',
          list: 0,
        },
        {
          text: 'Dias de mora',
          value: 'delinquency',
          id: 'delinquency',
          select: true,
          filtered: false,
          filtering: false,
          enabled: true,
          key: '0317',
          list: 2,
        },
        {
          text: 'Cartera',
          value: 'portfolio_type_id',
          id: 'id',
          select: true,
          filtered: false,
          filtering: false,
          enabled: true,
          key: '0319',
          list: 4,
        },
      ],
      structure: {
        first_name: 'first_name',
        last_name: 'last_name',
        account: 'account',
        agency: 'agency_id',
        var_1: '',
        var_2: 'invoiced_balance',
        var_3: '',
        var_4: '',
        var_5: '',
        var_6: '',
        var_7: '',
        var_8: '',
        var_9: '',
        var_10: '',
        var_11: '',
        var_12: '',
        var_13: '',
        var_14: '',
        var_15: '',
      },
      filters: {
        tranche_id: '',
        agency_id: '',
        due_day_id: '',
        delinquency: '',
        portfolio_type_id: '',
      },
      icons: {
        Compromiso: 'calendar-check',
        Contenido: 'inbox',
        Abono: 'hand-holding-usd',
        Gestionando: 'cogs',
        'Por gestionar': 'clock',
        'Sin contacto digital': 'phone-slash',
        'Promesa rota': 'calendar-times',
        'Fuera de gestion': 'user-times',
        Gestionado: 'clipboard-check',
        'Saldo bajo': 'sort-amount-down',
        'Sin contacto humano': 'user-slash',
      },
      lists: [
        [], // Tramo de mora
        [], // Agencia
        [], // Dias de mora
        [], // Dia de vencimiento
        [], // Cartera
      ],
      search: {
        tranche_id: '',
        delinquency: '',
        due_day_id: '',
        agency_id: '',
        portfolio_type_id: '',
      },
    };
  },
  computed: {
    formatedStartDate() {
      return this.form.start_date ? moment(this.form.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
    },
    formatedStartHour() {
      return this.form.start_date && this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`, 'YYYY-MM-DD H:mm A').format('h:mm A') : '';
    },
    textLength() {
      const vars = (this.text || 'Ejemplo @ ').split('@').length - 1;
      const length = (this.text || 'Ejemplo @ ').length + (vars * 10);
      return length;
    },
  },
  methods: {
    /* eslint-disable */
    fillVar(event, item) {
      if (!event) {
        this.structure[item.value] = '';
      }
    },
    fillFilter(event, item) {
      if (!event) {
        this.filters[item.value] = '';
      }
    },
    formatedText(text) {
      if (text !== '') {
        let replace, variableText;
        Object.keys(this.structure).forEach((key, i) => {
          variableText = `@${key === 'account' ? 'cuenta' : key === 'first_name' ? 'nombre' : key === 'last_name' ? 'apellido' : key === 'c_to' ? 'email' : key}`;
          variableText = new RegExp(variableText, 'g');
          if (i === 0) {
            replace = text.replace(variableText, `<span class="highlight-campaign-template">${this.customer[this.structure[key]]}</span>`);
          } else if (key === 'var_2' && this.customer[this.structure[key]]) {
            replace = replace.replace('@monto', `<span class="highlight-campaign-template">${this.campaign.channel === 'email' || this.campaign.channel === 'sms' ? `${new Intl.NumberFormat('es-VE').format(this.customer[this.structure[key]])}` : `${Math.round(this.customer[this.structure[key]])}`}</span>`);
          } else {
            replace = replace.replace(variableText, `<span class="highlight-campaign-template">${this.customer[this.structure[key]]}</span>`);
          }
        });
        return replace;
      }
    },
    getCustomersStatus() {
      this.filters_columns.forEach((item) => {
        if (!item.filtered) {
          this.filters[item.value] = '';
        }
      });
      this.axios.get(`/customers/grouping_status?${qs.stringify(this.filters)}&channel=${this.campaign.channel}`).then((response) => {
        this.statusOfCustomers = response.data;
        this.e1 += 1;
      });
    },
    getCampaign(number = null) {
      if (number != null) {
        this.e1 = number;
      }
      /* eslint-disable */
      this.axios.get(`/campaigns/${this.$route.params.campaign}?fields=channel,template_id,name,start_date,delivery_option,status`).then((response) => {
        this.campaign = response.data;
        if (this.campaign.channel !== 'bot') {
          this.axios.get(`/templates?type=campaign&paginate=0&notNull=${this.campaign.channel}&diff=template_code&diff-value=000`).then((resp) => {
            this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
            this.templates = resp.data;
          });
        } else {
          this.axios.get(`/bot_templates?fields=name,status,id,botTemplateDetails.name,botTemplateDetails.text&paginate=0&status=activo`).then((resp) => {
            this.campaign.template_id ? this.template = resp.data.find(o => o.id === this.campaign.template_id) : this.template = resp.data[0];
            this.templates = resp.data;
          });
        }
        //this.campaignSmyAndVar();
      }).catch(() => { });
    },
    cleanFilters() {
      this.filters = {};
      this.filters_columns.forEach((item) => {
        item.selected = '';
      });
      Promise.all([
        this.axios.get(`/customers/group_by_column?column=tranche_id&reference=1&column_name=tranche&table=tranches&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=agency_id&reference=1&column_name=agency&table=agencies&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=delinquency&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=due_day_id&reference=1&column_name=due_day&table=due_dates&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=portfolio_type_id&reference=1&column_name=portfolio_type&table=portfolio_types&channel=${this.campaign.channel}`),
      ]).then((values) => {
        this.lists[0] = values[0].data;
        this.lists[1] = values[1].data;
        this.lists[2] = values[2].data;
        this.lists[3] = values[3].data;
        this.lists[4] = values[4].data;
      });
    },
    getFilters() {
      Promise.all([
        this.axios.get(`/customers/group_by_column?column=tranche_id&reference=1&column_name=tranche&table=tranches&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=agency_id&reference=1&column_name=agency&table=agencies&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=delinquency&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=due_day_id&reference=1&column_name=due_day&table=due_dates&channel=${this.campaign.channel}`),
        this.axios.get(`/customers/group_by_column?column=portfolio_type_id&reference=1&column_name=portfolio_type&table=portfolio_types&channel=${this.campaign.channel}`),
      ]).then((values) => {
        this.lists[0] = values[0].data;
        this.lists[1] = values[1].data;
        this.lists[2] = values[2].data;
        this.lists[3] = values[3].data;
        this.lists[4] = values[4].data;
        this.e1 += 1;
      });
    },
    getClicked(event) {
      const object = this.filters_columns.find(item => item.key === event.target.id);
      object.filtering = !object.filtering;
    },
    // getFilteredFilters() {
    //   this.filters_columns.forEach((item) => {
    //     if (this.filters[item.value] === '') {
    //       let url = `/customers/group_by_column?column=${item.value}&${qs.stringify(this.filters)}&channel=${this.campaign.channel}`;
    //       this.axios.get(url).then((response) => {
    //         this.lists[this.list_order[item.value]] = response.data;
    //         this.lists[this.list_order[item.value]].unshift({
    //           text: 'Todos',
    //           [item.value]: '',
    //         });
    //         if (response.data.length === 0) {
    //           item.enabled = false;
    //         }
    //         item.key = String(randomBytes(16));
    //         this.$nextTick(() => {
    //           const select = document.getElementById(item.key);
    //           select.click();
    //         });
    //       });
    //     }
    //   });
    // },
    formatDate(date, typeDate, toFormat) { // eslint-disable-line
      return moment(date, typeDate).format(toFormat);
    },
    searchTemplates() {
      if (this.campaign.channel !== 'bot') {
        this.text = this.template[this.campaign.channel === 'email' ? 'text' : this.campaign.channel];
      }
      this.e1 = this.e1 += 1;
    },
    updateTemplate(channel, template) {
      this.axios.patch(`/templates/${template.id}`, {
        [channel === 'email' ? 'text' : channel]:template[channel === 'email' ? 'text' : channel],
      }).then(() => {
        this.axios.get('/customers/first').then((response) => {
          this.customer = response.data;
          this.e1 = this.e1 += channel === 'bot' ? 2 : 1;
        });
      }).catch(() => { });
    },
    confirmDeliveryOption() {
      if (this.form.delivery_option === 'Agendada') {
        this.axios.patch(`/campaigns/${this.$route.params.campaign}`, {
          structure: this.structure,
          template_id: this.template.id,
          filters: this.filters,
          customer_status: this.selectedStatusOfCustomers,
          delivery_option: this.form.delivery_option,
          start_date: this.form.start_date ? this.form.start_date : '',
          start_hour: this.form.start_hour ? moment(`${this.form.start_date} ${this.form.start_hour}:00`).local().utc().format('HH:mm') : '',
          status: 'En proceso',
        }).then(() => {
          this.$router.push('/campaigns');
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      } else {
        this.axios.patch(`/campaigns/${this.$route.params.campaign}`, {
          structure: this.structure,
          template_id: this.template.id,
          filters: this.filters,
          customer_status: this.selectedStatusOfCustomers,
          delivery_option: this.form.delivery_option,
          status: 'En proceso',
        }).then(() => {
          this.$router.push('/campaigns');
        }).catch((e) => {
          EventBus.$emit('modal', e.response.data);
        });
      }
    },
    /* eslint-enable */
  },
  watch: {
    template(val) {
      if (val) {
        this.form.template_id = val.id;
        if (this.campaign.channel !== 'bot') {
          // eslint-disable-next-line
          this.text = val[this.campaign.channel === 'email' ? 'text' : (this.campaign.channel === 'human' ? 'sms' : this.campaign.channel)];
        }
      }
    },
    text(val) {
      if (this.campaign.channel !== 'bot') {
        // eslint-disable-next-line
        this.template[this.campaign.channel === 'email' ? 'text' : (this.campaign.channel === 'human' ? 'sms' : this.campaign.channel)] = val;
      }
    },
    filters: {
      handler() {
        // this.getFilteredFilters();
      },
      deep: true,
    },
    form: {
      handler(val) {
        this.campaign.delivery_option = val.delivery_option;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.awesomplete.campaign {
  width: 97% !important;
}

.custom-error {
  position: relative;
  top: 170px;
}

.card__actions.custom-actions {
  position: relative;
  top: 170px;
}

.confirm-campaign--scrollbar > div {
  height:280px !important;
}

.accordion-content {
  height:auto;
}
.accordion-content .content {
  display:none;
  position: relative;
  transition-property:display;
  transition-duration: 5s !important;
}
.accordion-content .content.open {
  display:flex;
  -webkit-animation-name: open; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: open;
  animation-duration: 0.3s;
}
.accordion-content .content.close {
  -webkit-animation-name: close; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 0.3s; /* Safari 4.0 - 8.0 */
  animation-name: close;
  animation-duration: 0.3s;
  display:none;
}

.animate-first-pointer {
  animation: firstPointer 1s linear infinite;
}

.animate-second-pointer {
  animation: secondPointer 2s linear infinite;
}

.animate-third-pointer {
  animation: thirdPointer 3s linear infinite;
}

.vertical-divider-template-50 {
  height: 50px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  border-top-width: 2px !important;
  margin-left: 25% !important;
}

.vertical-divider-template-100 {
  height: 160px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 1px !important;
  margin-left: 25% !important;
}

.vertical-divider {
  height: 100px !important;
  width: 50% !important;
  border-left-color: rgba(0, 0, 0, 0.4) !important;
  border-left-width: 2px !important;
  margin-left: 50% !important;
}

@-webkit-keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@keyframes firstPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@keyframes secondPointer {
  50% {
    opacity: 0;
  }
}

@-webkit-keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

@keyframes thirdPointer {
  50% {
    opacity: 0;
  }
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Standard syntax */
@keyframes close {
  from {opacity:1;}
  to {opacity:0;}
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}

/* Standard syntax */
@keyframes open {
  from {opacity:0;}
  to {opacity:1;}
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignAssigned.vue